import enumerate from 'lib/enumerate';
import ActivityRecipient from 'entities/ActivityRecipient';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import PaymentCardCreator from 'payments/components/PaymentCardCreator.jsx';
import PaymentChargeCreator from 'payments/components/PaymentChargeCreator.jsx';
import Activity from 'entities/Activity';
import React from 'react';

const PAGE = enumerate([
  'cardCreator',
  'chargeCreator',
]);

const PaymentCreator = React.createClass({
  propTypes: {
    request: React.PropTypes.instanceOf(Activity).isRequired,
    recipient: React.PropTypes.instanceOf(ActivityRecipient).isRequired,
    onComplete: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      amount: this.props.request.getAmountPerPerson(),
      page: PAGE.cardCreator,
      cardErrors: [],
      token: '',
    };
  },

  onCardErrored(cardErrors) {
    this.setState({ cardErrors, page: PAGE.cardCreator });
  },

  handleContinue(amount, token) {
    this.setState({ amount, token, page: PAGE.chargeCreator });
  },

  renderPaymentCardCreator() {
    return (
      <PaymentCardCreator
        errors={this.state.cardErrors}
        request={this.props.request}
        onContinue={this.handleContinue}
        eventScreenName={EventTrackingConstants.SELECT_PAYMENT}
      />
    );
  },

  renderPaymentChargeCreator() {
    return (
      <PaymentChargeCreator
        token={this.state.token}
        amount={this.state.amount}
        request={this.props.request}
        recipient={this.props.recipient}
        onCardErrored={this.onCardErrored}
        onTransactionCreated={transaction => this.props.onComplete(transaction)}
        eventScreenName={EventTrackingConstants.CONFIRM_PAYMENT}
      />
    );
  },

  render() {
    const pages = {
      [PAGE.cardCreator]: this.renderPaymentCardCreator,
      [PAGE.chargeCreator]: this.renderPaymentChargeCreator,
    };
    return pages[this.state.page]();
  },
});

export default PaymentCreator;



// WEBPACK FOOTER //
// ./src/payments/components/PaymentCreator.jsx